module.exports = __webpack_public_path__ + "static/media/snooker-img.0c6a154a.png";